import types from "../types";
import state from "../defaultState";
import { fromJS } from "immutable";

const initialState = state.user;
export default function app(state = initialState, action) {
  switch (action.type) {
    case types.SET_GET_USER_DATA:
      return state.setIn(["data"], fromJS(action.payload.data));
    case types.SET_GET_USER_ERROR:
      return state.setIn(
        ["error"],
        fromJS(
          action.payload.response
            ? action.payload.response.error
            : action.payload.message
        )
      );
    default:
      return state;
  }
}
